// Modules
import JSZip from "jszip";

// Type Definitions
import type { UploadFile } from "antd/es/upload/interface";

export async function generateZipFile(fileList: UploadFile<any>[]) {
	const zip = new JSZip();

	/**
	 * @description To avoid CORS error on upload due to AWS WAF policy, we need to add a dummy text file of 5kB size
	 * This file will be removed by Backend based on the filename dummy.txt
	 */
	zip.file("dummy.txt", new Blob(["Welcome to CAG".repeat(360)], { type: "text/plain;charset=utf-8" }));

	for (const file of fileList) {
		const filename = file?.name;
		zip.file(filename, file?.originFileObj as Blob);
	}

	// Generate the complete zip file
	return zip
		.generateAsync({ type: "blob", compression: "DEFLATE", compressionOptions: { level: 9 } })
		.then((blobdata) => {
			return new Blob([blobdata]);
		})
		.catch(() => {
			return new Blob();
		});
}
